import {
  deepSetObject, digObject, toggleArray,
} from '@domain-group/javascript-utils'

import useBrand, { useBrandForm } from '@hooks/useBrand'

const updateSSODomains = (domain, entityState, setEntityState) => {
  const { options } = entityState
  const ssoDomains = digObject(entityState, 'options.sso_domains', [])

  const updatedSSODomains = toggleArray(ssoDomains, domain, { deepCompare: true })
  const updatedOptions = deepSetObject(options, 'sso_domains', updatedSSODomains)

  setEntityState({ options: updatedOptions })
}

const useManageBrandSSOModal = (params) => {
  const { brand: initBrand } = params

  const {
    callbacks: { updateBrand: updateFn },
    updating,
  } = useBrand(initBrand)

  const {
    entityState,
    handlers,
    setEntityState,
  } = useBrandForm(initBrand)

  return (
    {
      callbacks: {
        updateSSODomains: domain => updateSSODomains(domain, entityState, setEntityState),
        updateFn,
      },
      entityState,
      handlers,
      updating,
    }
  )
}

export default useManageBrandSSOModal
